export default __webpack_public_path__ + "static/media/banners.b517e96a.svg";